import { useRequestEmailDiscoveryTokenMutation } from "@graphql/auth/auth.g";
import { SubmitHandler, useForm } from "react-hook-form";

import { Button } from "@design-system/Button/Button";
import { FieldGroup } from "@design-system/FieldGroup/FieldGroup";
import { Form } from "@design-system/Form/Form";
import { TextField } from "@design-system/TextField/TextField";

type Inputs = {
  email: string;
};

type Props = {
  onSuccess: () => Promise<void> | void;
};

export const LoginForm = ({ onSuccess }: Props) => {
  const requestEmailDiscoveryTokenMutation =
    useRequestEmailDiscoveryTokenMutation();
  const requestEmailDiscoveryToken =
    requestEmailDiscoveryTokenMutation.mutateAsync;
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = async (values) => {
    const data = await requestEmailDiscoveryToken({ email: values.email });

    if (data.requestEmailDiscoveryToken?.success) {
      await onSuccess();
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FieldGroup label="Email" error={errors.email?.message} required>
        <TextField
          type="email"
          isPasswordManagerEnabled
          {...register("email", {
            required: { value: true, message: "This field is required" },
          })}
          transparent
        />
      </FieldGroup>
      <Button isLoading={isSubmitting} stretch type="submit">
        Login
      </Button>
    </Form>
  );
};
